import { HFlow, Icon, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import React from 'react'
import { lotacaoAgendamentoToString } from 'view/agenda/util-agenda'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { AgendamentoCidadaoModel } from '../../model-cidadao'

type AgendamentoCidadaoLotacaoAgendadaProps = Pick<AgendamentoCidadaoModel, 'lotacaoAgendada'>

export function AgendamentoCidadaoLotacaoAgendada(props: AgendamentoCidadaoLotacaoAgendadaProps) {
  const { lotacaoAgendada } = props

  return (
    <VFlow vSpacing={0.5}>
      <HFlow hSpacing={0.5}>
        <Icon icon='userFilled' size={1} fill='primary' />
        <HLabel title='Profissional:'>
          {lotacaoAgendamentoToString({
            nomeProfissional: formatNomeProfissional(lotacaoAgendada?.profissional),
            nomeCbo: lotacaoAgendada?.cbo?.nome,
            ineEquipe: lotacaoAgendada?.equipe?.ine,
            nomeEquipe: lotacaoAgendada?.equipe?.nome,
          })}
        </HLabel>
      </HFlow>
      <HFlow hSpacing={0.5}>
        <Icon icon='hospital' size={1} fill='primary' />
        <Text fontWeight='bold'> {lotacaoAgendada.unidadeSaude.nome?.titleCase()}</Text>
      </HFlow>
    </VFlow>
  )
}
